<template>
  <div class="login-wrap">
    <el-form class="login-inner" label-position="top" label-width="100px" :model="formLabelAlign" :rules="rules"
      ref="ruleForm">
      <el-form-item label="用户名" prop="userName">
        <el-input v-model="formLabelAlign.userName"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input v-model="formLabelAlign.password" type="password"></el-input>
      </el-form-item>
      <el-form-item label="验证码" prop="code">
        <el-row>
          <el-col :span="14">
            <el-input placeholder="验证码" v-model="formLabelAlign.code">
            </el-input>
          </el-col>
          <el-col :span="10">
            <div class="code" @click="refreshCode">
              <security :identifyCode="identifyCode"></security>
            </div>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-button style="width:100%;" type="primary" @click="checkLogin('ruleForm')">登录</el-button>
      </el-form-item>
    </el-form>
    <el-dialog :visible.sync="dialogVisibleCode" center width="400px">
      <el-form :rules="rules" ref="ruleForm" :model="formInline" class="demo-form-inline" :inline="true"
        style="width:100%;">
        <el-form-item label="验证码">
          <el-input v-model="formLabelAlign.GoogleCode" type="text" clearable placeholder="" size="mini">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="AdminLogin()">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  import security from '../utils/Sidentify.vue'
  export default {
    components: {
      security
    },
    data() {
      return {
        dialogVisibleCode: false,
        formInline: {
          code: ""
        },
        // 随机抽取四位数
        identifyCodes: '123456789QWERTYUIPASDFGHJKLZXCVBNM',
        identifyCode: '',
        formLabelAlign: {
          userName: '',
          password: '',
          GoogleCode: "",
        },
        dialogVisible: false,
        rules: {
          userName: [{
            required: true,
            message: '输入会员账号',
            trigger: 'blur'
          }],
          password: [{
            required: true,
            message: '输入密码',
            trigger: 'blur'
          }],
          code: [{
              required: true,
              message: '输入验证码',
              trigger: 'blur'
            },
            {
              validator: (rule, value, callback) => {
                if (value.toUpperCase() != this.identifyCode.toUpperCase()) {
                  callback(new Error("验证码不正确"));
                } else {
                  callback();
                }
              }
            }
          ],
        }
      };
    },
    methods: {
      AdminLogin() {
        let _this = this;
        var params = new URLSearchParams();
        params.append('userName', this.formLabelAlign.userName);
        params.append('password', this.formLabelAlign.password);
        params.append('GoogleCode', this.formLabelAlign.GoogleCode);
        this.$http({
          method: 'post',
          url: '/AdminLogin',
          data: params
        }).then(function (result) {
          if (result.data.code == 0) {
            _this.$store.commit('SetLogin', true);
            _this.$router.push({
              name: 'Index',
            })
          } else {
            _this.$alert(`${result.data.msg}`, {
              confirmButtonText: '确定',
            });
          }

        }).catch(function (error) {
          console.log(error);
        })

      },
      checkLogin(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let _this = this;
            var params = new URLSearchParams();
            params.append('userName', this.formLabelAlign.userName);
            params.append('password', this.formLabelAlign.password);
            this.$http({
              method: 'post',
              url: '/checkLogin',
              data: params
            }).then(function (result) {
              if (result.data.code == 0) {
                if (result.data.data.GoogleSecret == 0) {
                  _this.$router.push({
                    name: 'qrCode',
                    params: {
                      text: result.data.data.qrcode
                    }
                  })

                } else if (result.data.data.GoogleSecret == 1) {
                  _this.dialogVisibleCode = true;
                }
              } else {
                _this.$alert(`${result.data.msg}`, {
                  confirmButtonText: '确定',
                });
              }

            }).catch(function (error) {
              console.log(error);
            })

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 验证码处理
      randomNum(min, max) {
        return Math.floor(Math.random() * (max - min) + min)
      },

      // 刷新验证码
      refreshCode() {
        this.identifyCode = ''
        this.makeCode(this.identifyCodes, 4)
      },
      makeCode(o, l) {
        for (let i = 0; i < l; i++) {
          this.identifyCode += this.identifyCodes[
            this.randomNum(0, this.identifyCodes.length)
          ]
        }
      }
    },
    mounted() {
      this.identifyCode = '';
      this.makeCode(this.identifyCodes, 4);
    },
  }

</script>
<style scoped>
  .login-inner {
    width: 300px;
    margin: 100px auto 0;
    padding: 24px;
    border: 1px solid #ebebeb;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  }

  .el-form-item__content {
    line-height: inherit;
  }

</style>



// WEBPACK FOOTER //
// src/components/Admin/Login.vue